<template>
  <li class="nav-item nav-top mr-2 dropdown">
    <a
      class="nav-link dropdown-toggle"
      data-toggle="dropdown"
      id="cache-clear-drop"
      href="#"
      @click.prevent
      v-tooltip.bottom="'Önbellek Temizle'"
    >
      <i v-bind:class="['fas fa-sync', submit ? 'fa-spin' : '']"></i>
      <span class="d-inline d-lg-none ml-2 ml-lg-0">Önbellek Temizle</span>
    </a>
    <div
      class="dropdown-menu dropdown-menu-lg-right"
      aria-labelledby="cache-clear-drop"
    >
      <a class="dropdown-item" href="#" @click.prevent="clearShowcase">
        <i class="fas fa-th-large"></i>
        <span class="ml-3">Vitrin Önbelleğini Temizle</span>
      </a>
      <a class="dropdown-item" href="#" @click.prevent="clearFilters">
        <i class="fas fa-filter"></i>
        <span class="ml-3">Filtre Önbelleğini Temizle</span>
      </a>
      <a class="dropdown-item" href="#" @click.prevent="clearAll">
        <i class="fas fa-broom"></i>
        <span class="ml-3">Tüm Önbelleği Temizle</span>
      </a>
    </div>
  </li>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "CacheClear",
  data() {
    return {
      submit: false,
    };
  },
  methods: {
    ...mapActions("cacheClear", ["showcaseClear", "optimizeClear", "filterClear"]),
    clearShowcase() {
      if (this.submit) return;
      this.submit = true;
      this.showcaseClear({
        onSuccess: () => {
          this.submit = false;
          this.$toast.success("Vitrin önbelleği başarıyla temizlendi.");
        },
        onFinish: () => {},
      });
    },
    clearFilters() {
      if (this.submit) return;
      this.submit = true;
      this.filterClear({
        onSuccess: () => {
          this.submit = false;
          this.$toast.success("Filtre önbelleği başarıyla temizlendi.");
        },
        onError: () => {
          this.submit = false;
          this.$toast.error("Filtre önbelleği temizlenemedi.");
        },
      });
    },
    clearAll() {
      if (this.submit) return;
      this.submit = true;
      this.optimizeClear({
        onSuccess: () => {
          this.submit = false;
          this.$toast.success("Tüm önbellek başarıyla temizlendi.");
        },
        onError: () => {
          this.submit = false;
          this.$toast.error("Önbellek temizlenemedi.");
        },
      });
    },
  },
};
</script>
